import { minutesToTime } from './minutesToTime'

export const hoursToTime = (hours, format) => minutesToTime(hours * 60, format)
